import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import AppFeedComponents from "%/dynamic-component-editor/options/app-feed-components";
import SmartFeedLayout from "%/dynamic-component-editor/options/smart-feed-layout";
import ShowDots from "%/dynamic-component-editor/options/show-dots";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import SmartFeedPagination from "%/dynamic-component-editor/options/smart-feed-pagination";
import SmartFeedPageLimit from "%/dynamic-component-editor/options/smart-feed-page-limit";
import SmartFeedSeeAllDestination from "%/dynamic-component-editor/options/smart-feed-see-all-destination";
import SmartFeedSeeMoreText from "%/dynamic-component-editor/options/smart-feed-see-more-text";
import SmartFeedSeeAllText from "%/dynamic-component-editor/options/smart-feed-see-all-text";
import SmartFeedSeeMoreAlignment from "%/dynamic-component-editor/options/smart-feed-see-more-alignment";
import SmartFeedColumnMinWidth from "%/dynamic-component-editor/options/smart-feed-column-min-width";
import SmartFeedColumnMaxWidth from "%/dynamic-component-editor/options/smart-feed-column-max-width";
import SmartFeedCardAlignment from "%/dynamic-component-editor/options/smart-feed-card-alignment";

export default class AppFeedOptions extends BaseOptionsBundle {

  optionTitle = "Feed Options";
  static optionClassName = "i-dynamic-global-feed-bundle";

  inspectorToolGroup = "app-feed";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.GLOBAL_FEED_TOOL_SET,
  };

  constructor(values = {}, extraOptions = []) {

    super(values, [
      AppFeedComponents,
      SmartFeedLayout,
      new ShowDots({ "default": true }), // existing carousels keep their dots
      SmartFeedPagination,
      SmartFeedPageLimit,
      SmartFeedSeeAllDestination,
      SmartFeedSeeMoreText,
      SmartFeedSeeMoreAlignment,
      SmartFeedSeeAllText,
      SmartFeedColumnMinWidth,
      SmartFeedColumnMaxWidth,
      SmartFeedCardAlignment,
      ...extraOptions,
    ]);
  }
}
